export const obtenerParametro = (nombre) => {

    const params = new URLSearchParams(window.location.search);
    let resultado = params.get(nombre);

    if (resultado) {
        return resultado;
    }else {
        return 'none'
    }

}